<div class="section-card" [formGroup]="group">
    <div class="section-header">
        <span class="s-icon">🎓</span>
        <h3>Program &amp; Course</h3>
    </div>
    <div class="section-body">
        <div class="row g-3">
            <div class="col-md-6">
                <div class="field">
                    <label class="field-label">Program <span class="req">*</span></label>
                    <select [class.is-invalid]="group.get('program_id')?.invalid && group.get('program_id')?.touched"
                            class="f-select"
                            formControlName="program_id">
                        <option value="">Please Select Program</option>
                        @for (item of programs; track item.id) {
                            <option [value]="item.id">{{ item.name }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="field">
                    <label class="field-label">Course <span class="req">*</span></label>
                    <select class="f-select" formControlName="course_id">
                        <option value="">Please Select Course</option>
                        @for (item of courses; track item.id) {
                            <option [value]="item.id">{{ item.course_name }}</option>
                        }
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>
